import { render, staticRenderFns } from "./futrue.vue?vue&type=template&id=da16611e&scoped=true&"
import script from "./futrue.vue?vue&type=script&lang=ts&"
export * from "./futrue.vue?vue&type=script&lang=ts&"
import style0 from "./futrue.vue?vue&type=style&index=0&id=da16611e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da16611e",
  null
  
)

export default component.exports